import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';
import { ListOption } from '../modules/tcm-core.module';
import { ListOptionRequest } from '../modules/tcm-core.module';

@Injectable({
  providedIn: 'root'
})
export class ManufacturerDataService {

  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public getManufacturersOptionsAsync(query: string, cancellationToken: Promise<any>): Promise<ListOption<number>[]> {
    const request: ListOptionRequest = { searchString: query };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('manufacturers/options', request, cancellationToken);
  }

  deleteManufacturerColorAsync(id: number, cancellation: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('ManufacturerColors/DeleteManufacturerColor', id, cancellation);
  }

  ValidateManufacturerCode(ManufacturerId: number, code: any,Id:number, timeout: Promise<any>): Promise<boolean> {
    const request = { ManufacturerId: ManufacturerId, code: code ,Id:Id};
    return this.httpClient.getJsonAsync('ManufacturerColors/ValidateManufacturerCode', request, timeout);
  }

  checkManufacturerCodeExists(id: number, code: any, timeout: Promise<any>): Promise<boolean> {
    const request = { id: id, code: code };
    return this.httpClient.getJsonAsync('Manufacturers/CheckManufacturerCodeExists', request, timeout);
  }
}
